import {useSelector} from 'src/v2/state/store';
import type {SupportedCurrency} from 'src/v2/state/types';

export const useIsRelayWalletConnectCurrency = (
  selectedCurrency?: SupportedCurrency | null,
): boolean => {
  const storeSelectedCurrency = useSelector((state) => state.selectedCurrency);
  const walletConnectEnabled = useSelector(
    (state) => state.featureFlags.enable_pay_with_any_crypto_wallet_connect,
  );
  const nonStablesEnabled = useSelector(
    (state) =>
      state.featureFlags.enable_pay_with_any_crypto_wallet_connect_non_stables,
  );
  const currency = selectedCurrency ?? storeSelectedCurrency;

  if (
    !walletConnectEnabled ||
    !currency?.paymentOptions.includes('wallet_connect')
  ) {
    return false;
  }

  const {assetCode} = currency;
  if (assetCode === 'usdt') return true;
  return nonStablesEnabled && (assetCode === 'eth' || assetCode === 'sol');
};
